import { Box, Paper, Typography } from '@mui/material'
import React from 'react'

const PurchaseRequestVideoUrl = () => {
    return (
        <Paper elevation={0} className="cmnStyledPaper">
            <Box className="cardItemList">
                <Typography variant='h5'>Video URL:</Typography>
                <Typography variant='body1'>https://www.tiktok.com/@user207577419559/video/7233068238165249286</Typography>
            </Box>
            <Box className="cardItemList">
                <Typography variant='h5'>Notes:</Typography>
                <Typography variant='body1'>-</Typography>
            </Box>
            <Box className="cardIPrid">
                <Typography variant='body1'>PRID: <span>#15</span></Typography>
            </Box>
            <Box className="purchaseRqstDate">
                <Typography variant='h5'>Purchase Requested on:</Typography>
                <Typography variant='caption'>January 14, 2023 at 8:36 PM UTC</Typography>
            </Box>
        </Paper>
    )
}

export default PurchaseRequestVideoUrl